import { render } from "./StyleGuide.vue?vue&type=template&id=2c979780&scoped=true&ts=true"
import script from "./StyleGuide.vue?vue&type=script&lang=ts"
export * from "./StyleGuide.vue?vue&type=script&lang=ts"

import "./StyleGuide.vue?vue&type=style&index=0&id=2c979780&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c979780"]])

export default __exports__